<div>
  <div class="logo-header">
    <div
      *ngIf="customer"
      class="flex align-center menu-button"
      style="width: 110px; margin-top: 7px"
      (click)="toggleMenu()">
      <mat-icon svgIcon="burger-icon" class="burger-icon"></mat-icon>
      <span class="menu-text">MENÜ</span>
    </div>
    <img
      src="assets/logo.svg"
      alt="Logo"
      class="logo"
      [class.pointer]="customer"
      (click)="navigateToShop()" />
  </div>
</div>
